class y {
  footerCopyrightTextFormat;
  showDisclaimerLink;
  brand;
  countryCode;
  disclaimerLink;
  termsLink;
  cookiesPolicyLink;
  privacyPolicyLink;
  editorialPolicyLink;
  emailPolicyLink;
  constructor(i, t, o, e, l = "/disclaimer.php", s = "/terms.php", h = "/cookiesUK.php", r = "/privacyPolicy.php", n = "/editorialpolicy.php", c = "/emailPolicy.php") {
    this.footerCopyrightTextFormat = i, this.showDisclaimerLink = t, this.brand = o, this.countryCode = e, this.disclaimerLink = l, this.termsLink = s, this.cookiesPolicyLink = h, this.privacyPolicyLink = r, this.editorialPolicyLink = n, this.emailPolicyLink = c;
  }
  validate() {
    return this.footerCopyrightTextFormat.length !== 0 && this.brand.length !== 0 && this.countryCode.length !== 0 && this.disclaimerLink.length !== 0 && this.termsLink.length !== 0 && this.cookiesPolicyLink.length !== 0 && this.privacyPolicyLink.length !== 0 && this.editorialPolicyLink.length !== 0 && this.emailPolicyLink.length !== 0;
  }
}
export {
  y as DisclaimerSettings
};
//# sourceMappingURL=index.js.map
